import TrackWrapper from '~/components/common/TrackWrapper';
import { FeedItemType } from '~/constants/home';
import { BffFeedItem } from '~/contracts/home';
import ErrorBoundary from '~/utilities/ErrorBoundary';
import OrderPlacedCard from '../OrderStatusCards/OrderPlacedCard/OrderPlacedCard';
import PurchasedVehicleCard from '../OrderStatusCards/PurchasedVehicleCard/PurchasedVehicleCard';
import PurchaseInProgressCard from '../OrderStatusCards/PurchaseInProgressCard/PurchaseInProgressCard';
import ReservedVehicleCard from '../OrderStatusCards/ReservedVehicleCard/ReservedVehicleCard';

export default function feedItemMapper(feedItem: BffFeedItem) {
  let card: JSX.Element | null = null;

  const viewEvent = {
    eventName: 'Viewed - Home feed section',
    customAttributes: {
      description: 'Order status'
    }
  };

  switch (feedItem.type) {
    case FeedItemType.RETAIL_ORDER_PLACED:
    case FeedItemType.TRADE_ORDER_PLACED:
      card = (
        <TrackWrapper event={viewEvent}>
          <OrderPlacedCard feedItem={feedItem} />
        </TrackWrapper>
      );
      break;

    case FeedItemType.RETAIL_PURCHASE_IN_PROGRESS:
    case FeedItemType.TRADE_PURCHASE_IN_PROGRESS:
      card = (
        <TrackWrapper event={viewEvent}>
          <PurchaseInProgressCard feedItem={feedItem} />
        </TrackWrapper>
      );
      break;

    case FeedItemType.PURCHASE_POST_DELIVERY_0_7:
    case FeedItemType.PURCHASE_POST_DELIVERY_8_100:
      card = (
        <TrackWrapper event={viewEvent}>
          <PurchasedVehicleCard feedItem={feedItem} />
        </TrackWrapper>
      );
      break;

    case FeedItemType.RETAIL_PREORDER:
      card = (
        <TrackWrapper event={viewEvent}>
          <ReservedVehicleCard feedItem={feedItem} />
        </TrackWrapper>
      );
      break;

    default:
      return null;
  }

  return <ErrorBoundary key={feedItem.type}>{card}</ErrorBoundary>;
}
